import { PencilSimple } from "@phosphor-icons/react";
import { useState } from "react";

import Promotion from "common/components/Promotion";
import { Button } from "common/components/ui/Button";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import usePromotions from "common/datahooks/usePromotions";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { Promotion as PromotionType } from "common/types";

export default function Promotions() {
  const isDesktop = useTwBreakpoint("lg");
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const [isOpen, setIsOpen] = useState(false);
  const [promotionType, setPromotionType] =
    useState<PromotionType["type"]>(null);

  const { appSumoPromotion, ltdPromotion } = usePromotions();

  if (!appSumoPromotion && !ltdPromotion) return null;

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  return (
    <>
      <div className="justify-end flex gap-x-2 max-lg:w-full">
        {!!appSumoPromotion && (
          <Button
            variant="secondary-black"
            className="bg-appsumoYellow"
            size={isDesktop ? "sm" : "md"}
            onClick={() => {
              setPromotionType("appsumo");
              setIsOpen(true);
            }}
            rightIcon={<PencilSimple />}
          >
            AppSumo
          </Button>
        )}

        {!!ltdPromotion && (
          <Button
            size={isDesktop ? "sm" : "md"}
            onClick={() => {
              setPromotionType("ltd");
              setIsOpen(true);
            }}
            rightIcon={<PencilSimple />}
          >
            Lifetime seats
          </Button>
        )}
      </div>

      <Component open={isOpen} onOpenChange={setIsOpen}>
        <Content>
          <Promotion
            promotion={
              promotionType === "appsumo" ? appSumoPromotion : ltdPromotion
            }
            onClose={() => setIsOpen(false)}
            workspaceId={workspaceId}
          />
        </Content>
      </Component>
    </>
  );
}
